import React from 'react'
import {compose, lifecycle} from 'recompose'
import * as media from "../../media";
import _ from 'lodash'
import getUrl from "../../getUrl";
import CategoryHeader from '../../finwhale/common/category/header'
import CategoryText from "../../finwhale/common/category/text";
import CategoryTable from "../../finwhale/common/category/table";
import styled from "styled-components";
import CategoryNewList from '../../finwhale/common/category/new'
import HW from '../../static/HW.png'
import TranslateText from 'src/text/modal';

// Adapters
import UHookArm from '../../static/wiper-blades-adapters/Blade_U-HookArm.jpg';
import SidePinArm from '../../static/wiper-blades-adapters/Blade_SidePinArm.jpg';
import PushButtonArm from '../../static/wiper-blades-adapters/Blade_PushButtonArm.jpg';
import PinchTabArm from '../../static/wiper-blades-adapters/Blade_PinchTabArm.jpg';
import NewBayonetArm from '../../static/wiper-blades-adapters/Blade_NewBayonetArm.jpg';
import AdapterUHook from '../../static/wiper-blades-adapters/BladeHW_U-Hook_adapter.jpg';
import AdapterOE3 from '../../static/wiper-blades-adapters/BladeHW_OE3_adapter.jpg';
import UHookArmInstall from '../../static/wiper-blades-adapters/BladeHW_U-Hook_install.jpg';
import SidePinArmInstall from '../../static/wiper-blades-adapters/BladeHW_SidePin_install.jpg';
import PushButtonArmInstall from '../../static/wiper-blades-adapters/BladeHW_PushButton_install.jpg';
import PinchTabArmInstall from '../../static/wiper-blades-adapters/BladeHW_PinchTab_install.jpg';
import NewBayonetArmInstall from '../../static/wiper-blades-adapters/BladeHW_NewBayonetArm_install.jpg';



const AdapterText = () => <TranslateText id="catalogue_wiper_bladed__adapters-item-title" place="top" style={{ display: 'inline' }} />;
const RowStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  ${media.smallerThan(1001)`
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0px;
    .col {
      margin-right: 0 !important;
      margin-bottom: 40px;
    }
  `};
  
  .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 0;
    &:not(:last-child) { margin-right: 100px; }

    .title {
      margin-bottom: 10px;
      > span {
        color: #53a6d0;
        font-weight: bold;
      }
    }
    
    .compose {
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      img:first-child { margin-right: 10px; }
    }

    img {
      display: block;
      width: auto;
      &.one-item { width: 99px; }
      &.two-items { width: 198px; }
      &.three-items { width: 299px; }
      &.four-items { width: 396px; }
    }
  }
`;

const WipersHW = ({install_axis, loading}) => (
    <div>
        <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>

            <CategoryHeader
              name='catalogue_wiper_blades_hw__title'
              img={HW}
              box='catalogue_wiper_blades_hw__box'
              settingsText='catalogue_wiper_blades_hw__settings'
              protectedText='catalogue_wiper_blades_hw__protected'
              checkedText='catalogue_wiper_blades_hw__checked'
            />

            {
                install_axis &&
                <CategoryTable
                  install_axis={[install_axis.find(i => _.get(i, 'detail_[0].article', '').toLowerCase().includes('hw'))]}
                  loading={loading}
                  autosize
                />
            }

            <CategoryNewList type={22}/>

            <div style={{textAlign: 'center'}}>
      <TranslateText
        id={'catalogue_wiper_blades_hw__features'}
        place="bottom"
        useHtml
        controls={['bold']}
      />
      <br />
      <TranslateText id="catalogue_wiper_bladed__adapters-title" place="bottom" />
      <br />
      <RowStyled>
        <div className="col">
          <div className="title">
            U-Hook Arm <span>+</span> <AdapterText /> U-Hook
          </div>
          <div className="compose">
            <img src={UHookArm} className="one-item" />
            <img src={AdapterUHook} className="one-item" />
          </div>
          <div className="install">
            <img src={UHookArmInstall} className="three-items" />
          </div>
        </div>
        <div className="col">
          <div className="title">
            Side Pin Arm <span>+</span> <AdapterText /> OE 3
          </div>
          <div className="compose">
            <img src={SidePinArm} className="one-item" />
            <img src={AdapterOE3} className="one-item" />
          </div>
          <div className="install">
            <img src={SidePinArmInstall} className="three-items" />
          </div>
        </div>
        <div className="col">
          <div className="title">
            Push Button Arm <span>+</span> <AdapterText /> OE 3
          </div>
          <div className="compose">
            <img src={PushButtonArm} className="one-item" />
            <img src={AdapterOE3} className="one-item" />
          </div>
          <div className="install">
            <img src={PushButtonArmInstall} className="three-items" />
          </div>
        </div>
      </RowStyled>
      <RowStyled>
        <div className="col">
          <div className="title">
            Pinch Tab Arm  <span>+</span> <AdapterText /> OE 3
          </div>
          <div className="compose">
            <img src={PinchTabArm} className="one-item" />
            <img src={AdapterOE3} className="one-item" />
          </div>
          <div className="install">
            <img src={PinchTabArmInstall} className="three-items" />
          </div>
        </div>
        <div className="col">
          <div className="title">
            New Bayonet Arm  <span>+</span> <AdapterText /> OE 3
          </div>
          <div className="compose">
            <img src={NewBayonetArm} className="one-item" />
            <img src={AdapterOE3} className="one-item" />
          </div>
          <div className="install">
            <img src={NewBayonetArmInstall} className="three-items" />
          </div>
        </div>
      </RowStyled>
    </div>

            <CategoryText
                advantages={'catalogue_wiper_blades__additional_benefits'}
            />

        </div>
    </div>
)

const enhance = compose(
  lifecycle({
    state: {loading: true},
    componentDidMount() {
      fetch(getUrl(`/cat/v1/item?type_id=22&jsonaggr={"columns":{"id":"count"},"group":["type_wiper"]}`)).then(data => {
        return data.json()
      }).then(listItems => {
        const install_axis = _.get(listItems, 'data.data')
        this.setState({install_axis, loading: false})
      }).catch(err => {
        console.log(err)
      })
    },
  }),
)

export default enhance(WipersHW)



// WEBPACK FOOTER //
// ./src/pages/production/wipers-blade-hw.js